export { RenameWorkspaceFolderDialog } from './RenameWorkspaceFolderDialog';
export { useRenameWorkspaceFolderDialog } from './useRenameWorkspaceFolderDialog';
